import type { SearchFnProps } from ".";
import { absolutePath } from "../absolutePath";
import type { PAYWALL_STATUS } from "@circle-react/types/Paywall";

export interface PaywallIndexQueryParams {
  params?: {
    page?: number;
    [key: string]: any;
    filters?: {
      status?: typeof PAYWALL_STATUS.ACTIVE | typeof PAYWALL_STATUS.INACTIVE;
    };
    query?:
      | string
      | {
          not_subscription_group?:
            | string
            | number
            | Array<string>
            | Array<number>;
          subscription_group?: string | Array<string>;
          type?: "Paywall" | "Paywalls::Event";
          trial_days?: number;
          price_type?: string;
          paywall_id?: string | number;
          name?: string;
          access_groups?: string | Array<string>;
        };
  };
}

export const paywalls = {
  index: ({ params }: PaywallIndexQueryParams) =>
    absolutePath("search/paywalls", params),
};

export const paywallsAffiliates = {
  index: ({ params = {} }: SearchFnProps) =>
    absolutePath("search/paywalls/affiliates", params),
};

export const paywallsAffiliatesCommissions = {
  index: (params: SearchFnProps["params"] = {}) =>
    absolutePath("search/paywalls/affiliates/commissions", params),
};
